import { render } from "./ProductionCost.vue?vue&type=template&id=e937e0ca&scoped=true"
import script from "./ProductionCost.vue?vue&type=script&lang=ts"
export * from "./ProductionCost.vue?vue&type=script&lang=ts"

import "./ProductionCost.vue?vue&type=style&index=0&id=e937e0ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e937e0ca"

export default script